module.exports = __webpack_public_path__ + "img/horror.334fa497.svg";